/**
 * General Services class
 */
import RestClient from '../Client/RestClient'
import Configuration from '../Api/Configuration'

const { User_EndPoints, Subscription_EndPoints } = Configuration

class SubscriptionServices {
  static getBootData (header) {
    return RestClient.getRequest(Subscription_EndPoints.boot, header, true)
  }

  static getProfileData (header) {
    return RestClient.getRequest(User_EndPoints.profile, header, true)
  }

  static getCountries (header) {
    return RestClient.getRequest(User_EndPoints.countries, header)
  }

  static getGovernments (country, header) {
    return RestClient.getRequest(`/country/${country}/government`, header)
  }

  static getCities (government, header) {
    return RestClient.getRequest(`/government/${government}/city`, header)
  }

  static getUsers (header) {
    return RestClient.getRequest(Subscription_EndPoints.users, header, true)
  }

  static exportUsers (header) {
    return RestClient.getRequest(Subscription_EndPoints.exportUsers, header, true)
  }

  static activateDeactivateUser (userId, data, header, setFormLoading) {
    return RestClient.patchRequest(Subscription_EndPoints.users + `/${userId}`, data, header, setFormLoading, null, null, true)
  }

  static sendResetPasswordOTP (userId, header) {
    return RestClient.getRequest(Subscription_EndPoints.users + `/${userId}/reset-password`, header, true)
  }

  static getUserProfileData (userId, header) {
    return RestClient.getRequest(Subscription_EndPoints.users + `/${userId}`, header, true)
  }

  static updateUserProfileData (userId, data, header, setFormLoading, setFailure, FormikActions) {
    return RestClient.putRequest(Subscription_EndPoints.users + `/${userId}`, data, header, setFormLoading, setFailure, FormikActions, true)
  }

  static getPaymentRequests (header) {
    return RestClient.getRequest(Subscription_EndPoints.paymentRequests, header, true)
  }

  static exportPaymentRequests (header) {
    return RestClient.getRequest(Subscription_EndPoints.exportPaymentRequests, header, true)
  }

  static getPaymentReceipts (header) {
    return RestClient.getRequest(Subscription_EndPoints.paymentReceipts, header, true)
  }

  static exportPaymentReceipts (header) {
    return RestClient.getRequest(Subscription_EndPoints.exportPaymentReceipts, header, true)
  }

  static getActivityLog (header) {
    return RestClient.getRequest(Subscription_EndPoints.activityLog, header, true)
  }

  static getPermissions (header) {
    return RestClient.getRequest(Subscription_EndPoints.permissions, header, true)
  }

  static getRoles (header) {
    return RestClient.getRequest(Subscription_EndPoints.roles, header, true)
  }

  static getRoleData (roleId, header) {
    return RestClient.getRequest(Subscription_EndPoints.roles + `/${roleId}`, header, true)
  }

  static updateRole (roleId, data, header, setFormLoading, setFailure, FormikActions) {
    return RestClient.putRequest(Subscription_EndPoints.roles + `/${roleId}`, data, header, setFormLoading, setFailure, FormikActions, true)
  }

  static submitRole (roleId, isEdit, data, header, setFormLoading, setFailure, FormikActions) {
    return !!isEdit ? RestClient.putRequest(Subscription_EndPoints.roles + `/${roleId}`, data, header, setFormLoading, setFailure, FormikActions, true)
      : RestClient.postRequest(Subscription_EndPoints.roles, data, header, setFormLoading, setFailure, FormikActions, true)
  }

  static deleteRole (roleId, header, setFormLoading) {
    return RestClient.deleteRequest(Subscription_EndPoints.roles + `/${roleId}`, header, setFormLoading, null, null, true)
  }

  static getSettings (header) {
    return RestClient.getRequest(Subscription_EndPoints.settings, header, true)
  }

  static updateSetting (settingId, data, header, setFormLoading) {
    return RestClient.patchRequest(Subscription_EndPoints.settings + `/${settingId}`, data, header, setFormLoading, null, null, true)
  }

  static addNewAdmin (data, header, setFormLoading, setFailure, FormikActions) {
    return RestClient.postRequest(Subscription_EndPoints.addAdmin, data, header, setFormLoading, setFailure, FormikActions, true)
  }

  static getPages (header) {
    return RestClient.getRequest(Subscription_EndPoints.pages, header, true)
  }

  static updatePage (pageId, data, header, setFormLoading, setFailure, FormikActions) {
    return RestClient.putRequest(Subscription_EndPoints.pages + `/${pageId}`, data, header, setFormLoading, setFailure, FormikActions, true)
  }

  static getPageData (pageId, header) {
    return RestClient.getRequest(Subscription_EndPoints.pages + `/${pageId}`, header, true)
  }

  static submitPage (pageId, isEdit, data, header, setFormLoading, setFailure, FormikActions) {
    return !!isEdit ? RestClient.putRequest(Subscription_EndPoints.pages + `/${pageId}`, data, header, setFormLoading, setFailure, FormikActions, true)
      : RestClient.postRequest(Subscription_EndPoints.pages, data, header, setFormLoading, setFailure, FormikActions, true)
  }

  static deletePage (pageId, header, setFormLoading) {
    return RestClient.deleteRequest(Subscription_EndPoints.pages + `/${pageId}`, header, setFormLoading, null, null, true)
  }

  static getCategories (header) {
    return RestClient.getRequest(Subscription_EndPoints.categories, header, true)
  }

  static getUserGroups (header) {
    return RestClient.getRequest(Subscription_EndPoints.userGroups, header, true)
  }

  static deleteUserGroup (userGroupId, header, setFormLoading) {
    return RestClient.deleteRequest(Subscription_EndPoints.userGroups + `/${userGroupId}`, header, setFormLoading, null, null, true)
  }

  static searchUsers (header) {
    return RestClient.getRequest(Subscription_EndPoints.users, header, true)
  }

  static getUserGroupData (userGroupId, header) {
    return RestClient.getRequest(Subscription_EndPoints.userGroups + `/${userGroupId}`, header, true)
  }

  static submitUserGroup (userGroupId, isEdit, data, header, setFormLoading, setFailure, FormikActions) {
    return !!isEdit 
      ? RestClient.putRequest(Subscription_EndPoints.userGroups + `/${userGroupId}`, data, header, setFormLoading, setFailure, FormikActions, true)
      : RestClient.postRequest(Subscription_EndPoints.userGroups, data, header, setFormLoading, setFailure, FormikActions, true)
  }

  static bulkImportUserGroups (data, header, setFormLoading, setFailure, FormikActions) {
    return RestClient.postRequest(Subscription_EndPoints.userGroupsBulkImport, data, header, setFormLoading, setFailure, FormikActions, true)
  }

  static bulkImportExternalEntityGroups (data, header, setFormLoading, setFailure, FormikActions) {
    return RestClient.postRequest(Subscription_EndPoints.externalEntityGroupsBulkImport, data, header, setFormLoading, setFailure, FormikActions, true)
  }

  static getExternalServiceHandlers (header) {
    return RestClient.getRequest(Subscription_EndPoints.externalServiceHandler, header, true)
  }
  static getExternalEntityGroups (header) {
    return RestClient.getRequest(Subscription_EndPoints.externalEntityGroups, header, true)
  }

  static deleteExternalEntityGroup (externalEntityGroupId, header, setFormLoading) {
    return RestClient.deleteRequest(Subscription_EndPoints.externalEntityGroups + `/${externalEntityGroupId}`, header, setFormLoading, null, null, true)
  }

  static getExternalEntityGroupData (externalEntityGroupId, header) {
    return RestClient.getRequest(Subscription_EndPoints.externalEntityGroups + `/${externalEntityGroupId}`, header, true)
  }

  static submitExternalEntityGroup (externalEntityGroupId, isEdit, data, header, setFormLoading, setFailure, FormikActions) {
    return !!isEdit 
      ? RestClient.putRequest(Subscription_EndPoints.externalEntityGroups + `/${externalEntityGroupId}`, data, header, setFormLoading, setFailure, FormikActions, true)
      : RestClient.postRequest(Subscription_EndPoints.externalEntityGroups, data, header, setFormLoading, setFailure, FormikActions, true)
  }
  
  static getPromocodes (header) {
    return RestClient.getRequest(Subscription_EndPoints.promocodes, header, true)
  }
  
  static getPromocodeData (promoId, header) {
    return RestClient.getRequest(Subscription_EndPoints.promocodes + `/${promoId}`, header, true)
  }

  static submitPromocode (promocodeId, isEdit, data, header, setFormLoading, setFailure, FormikActions) {
    return !!isEdit 
      ? RestClient.putRequest(Subscription_EndPoints.promocodes + `/${promocodeId}`, data, header, setFormLoading, setFailure, FormikActions, true)
      : RestClient.postRequest(Subscription_EndPoints.promocodes, data, header, setFormLoading, setFailure, FormikActions, true)
  }

  static bulkImportPromocodes (data, header, setFormLoading, setFailure, FormikActions) {
    return RestClient.postRequest(Subscription_EndPoints.promocodesBulkImport, data, header, setFormLoading, setFailure, FormikActions, true)
  }

  static deletePromocode (promocodeId, header, setFormLoading) {
    return RestClient.deleteRequest(Subscription_EndPoints.promocodes + `/${promocodeId}`, header, setFormLoading, null, null, true)
  }

  static updateCategory (categoryId, data, header, setFormLoading, setFailure, FormikActions) {
    return RestClient.putRequest(Subscription_EndPoints.categories + `/${categoryId}`, data, header, setFormLoading, setFailure, FormikActions, true)
  }

  static getCategoryData (categoryId, header) {
    return RestClient.getRequest(Subscription_EndPoints.categories + `/${categoryId}`, header, true)
  }

  static submitCategory (categoryId, isEdit, data, header, setFormLoading, setFailure, FormikActions) {
    return !!isEdit ? RestClient.putRequest(Subscription_EndPoints.categories + `/${categoryId}`, data, header, setFormLoading, setFailure, FormikActions, true)
      : RestClient.postRequest(Subscription_EndPoints.categories, data, header, setFormLoading, setFailure, FormikActions, true)
  }

  static deleteCategory (categoryId, header, setFormLoading) {
    return RestClient.deleteRequest(Subscription_EndPoints.categories + `/${categoryId}`, header, setFormLoading, null, null, true)
  }

  static getServices (header) {
    return RestClient.getRequest(Subscription_EndPoints.services, header, true)
  }

  static updateService (serviceId, data, header, setFormLoading, setFailure, FormikActions) {
    return RestClient.putRequest(Subscription_EndPoints.services + `/${serviceId}`, data, header, setFormLoading, setFailure, FormikActions, true)
  }

  static getServiceData (serviceId, header) {
    return RestClient.getRequest(Subscription_EndPoints.services + `/${serviceId}`, header, true)
  }

  static submitService (serviceId, isEdit, data, header, setFormLoading, setFailure, FormikActions) {
    return !!isEdit ? RestClient.putRequest(Subscription_EndPoints.services + `/${serviceId}`, data, header, setFormLoading, setFailure, FormikActions, true)
      : RestClient.postRequest(Subscription_EndPoints.services, data, header, setFormLoading, setFailure, FormikActions, true)
  }

  static deleteService (serviceId, header, setFormLoading) {
    return RestClient.deleteRequest(Subscription_EndPoints.services + `/${serviceId}`, header, setFormLoading, null, null, true)
  }

  static getServiceHandlers (header) {
    return RestClient.getRequest(Subscription_EndPoints.serviceHandlers, header, true)
  }

  static getPlans (header) {
    return RestClient.getRequest(Subscription_EndPoints.plans, header, true)
  }

  static updatePlan (planId, data, header, setFormLoading, setFailure, FormikActions) {
    return RestClient.putRequest(Subscription_EndPoints.plans + `/${planId}`, data, header, setFormLoading, setFailure, FormikActions, true)
  }

  static getPlanData (planId, header) {
    return RestClient.getRequest(Subscription_EndPoints.plans + `/${planId}`, header, true)
  }

  static submitPlan (planId, isEdit, data, header, setFormLoading, setFailure, FormikActions) {
    return !!isEdit ? RestClient.putRequest(Subscription_EndPoints.plans + `/${planId}`, data, header, setFormLoading, setFailure, FormikActions, true)
      : RestClient.postRequest(Subscription_EndPoints.plans, data, header, setFormLoading, setFailure, FormikActions, true)
  }

  static deletePlan (planId, header, setFormLoading) {
    return RestClient.deleteRequest(Subscription_EndPoints.plans + `/${planId}`, header, setFormLoading, null, null, true)
  }

  static getPlansReport (header) {
    return RestClient.getRequest(Subscription_EndPoints.plansReport, header, true)
  }

  static exportPlansReport (header) {
    return RestClient.getRequest(Subscription_EndPoints.exportPlansReport, header, true)
  }

  static getServicesReport (header) {
    return RestClient.getRequest(Subscription_EndPoints.servicesReport, header, true)
  }

  static exportServicesReport (header) {
    return RestClient.getRequest(Subscription_EndPoints.exportServicesReport, header, true)
  }

  static getSubscriptionsReport (header) {
    return RestClient.getRequest(Subscription_EndPoints.subscriptionsReport, header, true)
  }

  static exportSubscriptionsReport (header) {
    return RestClient.getRequest(Subscription_EndPoints.exportSubscriptionsReport, header, true)
  }

}

export default SubscriptionServices
